type ProductLike = { product_id?: string | number }

/** Retire les produits listés, comparés en chaîne : les API mêlent nombres et chaînes. */
export const withoutProducts = <T extends ProductLike>(
  products: T[],
  hiddenIds: Array<string | number>
): T[] => {
  if (hiddenIds.length === 0) return products
  const hidden = new Set(hiddenIds.map(String))
  return products.filter(product => !hidden.has(String(product.product_id)))
}

// Ce que le serveur dit d'un produit DANS une liste. Le même produit peut figurer dans deux listes :
// l'enrichissement, indexé par produit, ne doit pas donner à l'une la raison de l'autre.
const REASON_FIELDS = [
  'reorder_reason',
  'reorder_qty',
  'reorder_reference_ts',
  'reorder_interval_days',
  'reorder_days_since',
  'common_buyers',
  'social_proof_buyers',
] as const

export const withOwnReason = (enriched: any, product: any): any => {
  const result = { ...enriched }
  for (const field of REASON_FIELDS) {
    result[field] = product[field]
  }
  return result
}
